<template>
  <el-select v-model="myVal" collapse-tags clearable filterable :multiple="value | isArray">
    <el-checkbox v-model="checked" class="all-choose" @change="checkboxChange">
      {{ '全选' | translateTo(i18nPath) }}
    </el-checkbox>
    <el-option v-for="v in optionArr" :key="v.value" :label="v.label" :value="v.value">
      <span v-if="translateLabel">{{ v.label | translateTo(i18nPath) }}</span>
      <span v-else>{{ v.label }}</span>
    </el-option>
  </el-select>
</template>

<script>
import { isArray } from 'lodash';

export default {
  props: {
    i18nPath: String,
    translateLabel: Boolean,
    value: [String, Array],
    optionArr: Array
  },
  data() {
    return {
      checked: false,
      myVal: this.value
    };
  },
  filters: {
    isArray(d) {
      return isArray(d);
    }
  },
  methods: {
    checkboxChange(newVal) {
      if (newVal) {
        this.myVal = this.optionArr.map(e => e.value);
      } else {
        this.myVal = [];
      }
    }
  },
  watch: {
    value(newVal) {
      this.myVal = newVal;
    },
    myVal(newVal) {
      this.$emit('input', newVal);
      if (this.myVal.length < this.optionArr.length && this.checked) this.checked = false;
      if (this.myVal === this.optionArr.length) this.checked = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.all-choose {
  text-align: right;
  width: 100%;
  padding-right: 20px;
  box-sizing: border-box;
}
</style>
